module.exports = __webpack_public_path__ + "static/media/speaking-3.5aba81a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/slider/speaking-3.jpg
// module id = 617
// module chunks = 6